module.exports = __webpack_public_path__ + "img/567x600px-Korlat.e9588378.jpg";